import axios from 'axios';

import { apiRequest } from './apiRequest';
import { CONST } from '../constant';

/**
 * fetch login member's joined communities
 * @returns {Promise}
 */
export const fetchEvent = async (cid, yearMonth, wide) => {
  // Resolve with the HTTP body (the month-keyed { d<ym>: [event...] } object); CalendarComponent
  // iterates the keys directly. apiRequest resolves the full axios response, so unwrap `.data`.
  const result = await apiRequest(`/api/event/list/${cid}/${yearMonth}/${wide ? 1 : 0}`, CONST.api_method.get);
  return result.data;
};

/**
 * @returns Promise<{ event: Event | null }
 */
export const getEvent = async eid => {
  const result = await apiRequest(`/api/event/get/${eid}`, CONST.api_method.get);
  return result.data;
};

/**
 response is cmid array
 */
export const getShareMembers = async eid => {
  const result = await apiRequest(`/api/event/members/${eid}/`, CONST.api_method.get);
  return result.data;
};

/**
 this looks like getShareMembers above.
 response is like 'm1','m2'....
 this is allowed only creator
 */
export const getShareTargets = async eid => {
  const result = await apiRequest(`/api/event/targets/${eid}/`, CONST.api_method.get);
  return result.data;
};

export const createEvent = async data => {
  return await apiRequest('/api/event/create', CONST.api_method.post, data);
};

export const deleteEvent = async eid => {
  return await apiRequest(`/api/event/delete/${eid}/`, CONST.api_method.post);
};

export const deleteOnlyOneEvent = async (eid, uid) => {
  return await apiRequest(`/api/event/delete-one/${eid}/${uid}/`, CONST.api_method.post);
};

export const editEvent = async (eid, data) => {
  return await apiRequest(`/api/event/update/${eid}/`, CONST.api_method.post, data);
};

export default {
  fetchEvent,
  getEvent,
  getShareMembers,
  getShareTargets,
  createEvent,
  deleteEvent,
  deleteOnlyOneEvent,
  editEvent,
};
